import React from 'react';
import {observer} from 'mobx-react';
import {Button} from '../../../../basic-ui-components/button/base/button.component';
import {AppIdentifiers, AreaType} from "@sparkware/uc-sdk-core";
import {useServices} from "../../../../react-hooks/use-services.hook";

export const HelpButtonComponent: React.FC = observer(() => {
  const services = useServices();

  const handleClick = async () => {
    services.analytics.sendOrbitUserFlowEvent("Navigation", "Header", "Help");
    await (await services.appLauncher).openHelpCenter({
      businessCorrelationID: services.tools.getGuid(),
      channel: {
        area: AreaType.PCHeader,
        element: AppIdentifiers.CRHelpCenter,
        source: AppIdentifiers.CasinoClient
      }
    });
  }

  return (
      <Button
          className={"cy-header-help-button"}
          preset="flatStroked"
          icon={{Component: services.theme.currentTheme.icons.helpIcon}}
          onClick={handleClick}
          margin="0 0.4rem"
      />
  );
});
